import styled from 'styled-components';
import { Section } from './Layout';

export const HeroSection = styled(Section)`
  text-align: center;
  padding: 20px 0 60px 0;
  position: relative;
  margin-top: 30px;
  
  &::before {
    content: '';
    position: absolute;
    top: -50px;
    right: -100px;
    width: 200px;
    height: 200px;
    background: radial-gradient(circle, rgba(0, 102, 255, 0.1) 0%, transparent 70%);
    border-radius: 50%;
    z-index: -1;
    opacity: 0.6;
  }
  
  &::after {
    content: '';
    position: absolute;
    bottom: -50px;
    left: -100px;
    width: 200px;
    height: 200px;
    background: radial-gradient(circle, rgba(0, 102, 255, 0.1) 0%, transparent 70%);
    border-radius: 50%;
    z-index: -1;
    opacity: 0.6;
  }
`;

export const Heading = styled.h1`
  font-size: 3.5rem;
  font-weight: 800;
  margin-bottom: 20px;
  line-height: 1.1;
  color: #1a1a1a;
  background: linear-gradient(135deg, #1a1a1a 0%, #333 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  position: relative;
  display: inline-block;
  
  &::after {
    content: '';
    position: absolute;
    bottom: -10px;
    left: 50%;
    transform: translateX(-50%);
    width: 100px;
    height: 3px;
    background: linear-gradient(90deg, rgba(0,102,255,0.2) 0%, rgba(0,102,255,0.8) 50%, rgba(0,102,255,0.2) 100%);
    border-radius: 3px;
  }
`;

export const SubHeading = styled.h2`
  font-size: 1.5rem;
  font-weight: 400;
  margin-bottom: 40px;
  line-height: 1.5;
  color: #555;
  max-width: 800px;
  margin-left: auto;
  margin-right: auto;
  position: relative;
  
  strong {
    color: #0066ff;
    font-weight: 600;
  }
`; 